/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import { useToast } from "../../../context/toast-context";
import useAPIHandler from "../../../hook/use-api-handler";
import { logger } from "../../../utils/logger";


const useEmployeeImportSevice = ({handleCloseImportModal,getEmployeeListFn,openImportModal}) => {
    const [isLoadingBtn, setIsLoadingBtn] = useState(false);
    const [errorLogs, setErrorLogs] = useState([]);
    const [importSuccessMsg, setImportSuccessMsg] = useState(null)
    const [isDragging, setIsDragging] = useState(false);
    const [file, setFile] = useState("");
    const [fileName, setFileName] = useState("");
    const { fetchData } = useAPIHandler();
    const { showToastMessage } = useToast();
    const[isImportBtnDisable,setIsImportBtnDisable]=useState(true)
    const[isValidateBtnDisable,setIsValidateBtnDisable]=useState(true)
    const[showTryAgainBtn,setShowTryAgainBtn]=useState(false);
    const [readyToUploadData,setReadyToUploadData]=useState(null)
    const finalUploadEmployeeCSV = async (readyToUploadData) => {
        setIsLoadingBtn(true);
        try {
            const payload = {data:readyToUploadData}
            const response = await fetchData({
                url: "/employee/employee-import-create",
                method: "POST",
                data: payload
            })
            setIsLoadingBtn(false);
            showToastMessage({ message: "Employee Added successfully!" });
            handleCloseImportModal()
            getEmployeeListFn()
        } catch (error) {
            logger.error(error);
            setIsLoadingBtn(false);
        }
    }
    const handleFileChange = async (event) => {
        setErrorLogs([])
        setImportSuccessMsg(null)
        const file = event.target.files[0];
        if (file.type === "text/csv") {
            setFileName(file.name);
            setFile(file)
            setIsValidateBtnDisable(false)
        } else {
            showToastMessage({ message: "Please upload a valid .csv file", color: "danger" })
        }
    };
    const ValidateUploadEmployeeCSV = async (file) => {
        setIsLoadingBtn(true);
        const formData = new FormData();
        formData.append('file', file);
        try {
            const response = await fetchData({
                url: "/employee/employee-import",
                method: "POST",
                data: formData
            })
            if (response?.data?.status == true) {
                // finalUploadEmployeeCSV(response?.data?.data);
                setIsValidateBtnDisable(true)
                setImportSuccessMsg(response?.data?.message)
                setReadyToUploadData(response?.data?.data)
                setIsImportBtnDisable(false)
            }
            setIsLoadingBtn(false);
        } catch (error) {
            setErrorLogs(error?.details?.data?.errorLogs);
            setIsLoadingBtn(false);
            setShowTryAgainBtn(true)
        }
    }


    const handleDrop = (event) => {
        event.preventDefault();
        setIsDragging(false);
        const file = event.dataTransfer.files[0];
        if (file) {
            if (file.type === "text/csv") {
                setFileName(file.name);
            } else {
                showToastMessage({ message: "Please upload a valid .csv file", color: "danger" })
            }
        }
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = () => setIsDragging(false);

    const handleSampleCSVdownload = () => {
        const link = document.createElement("a");
        link.href = "/Employee_Sample.csv"; // File path relative to the public folder
        link.download = "Employee_Sample.csv"; // File name for the download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const handleTryAgainBtn = () => {
        setFileName('');
        setErrorLogs([]);
        setImportSuccessMsg('');
        setIsImportBtnDisable(true);
        setShowTryAgainBtn(false);
      };
    useEffect(() => {
        handleTryAgainBtn();
    }, [openImportModal, handleCloseImportModal]);
    
    return {
        ValidateUploadEmployeeCSV,
        handleFileChange,
        errorLogs,
        importSuccessMsg,
        handleDrop,
        handleDragOver,
        handleDragLeave,
        isDragging,
        fileName,
        file,
        isLoadingBtn,
        handleSampleCSVdownload,
        isImportBtnDisable,
        showTryAgainBtn,
        isValidateBtnDisable,
        finalUploadEmployeeCSV,
        handleTryAgainBtn,
        readyToUploadData
    }
}

export default useEmployeeImportSevice